import { render, staticRenderFns } from "./IconValue.vue?vue&type=template&id=0e48391d&scoped=true&"
import script from "./IconValue.vue?vue&type=script&lang=js&"
export * from "./IconValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e48391d",
  null
  
)

export default component.exports